import { api } from '~/services/api'
import { $userInfo } from '~/store/user-info'

/**
 * Non-IAP currency purchase (no native store, no receipt system) — the
 * server debits the price itself. HTTP 422 means insufficient balance.
 */
export function purchaseProduct(productId: number) {
  const userId = $userInfo.get()?.user_id
  return api.service
    .post(`store/users/${userId}/purchase`, {
      json: { product_id: productId, quantity: 1 },
    })
    .json<{ results: Array<{ purchase?: { id: number } }> }>()
}
